module.exports = __webpack_public_path__ + "static/media/caves.46b3fb85.jpg";